import moment from 'moment';
import {
  SET_CHANHGED_SHUTDOWN_FILTER,
  SET_VISIBLE_SHUTDOWN_FILTER,
  SET_CHOSEN_SHUTDOWN_FILTER,
  SET_COMPANY_ID_SHUTDOWN_FILTER,
  SET_TYPE_ID_SHUTDOWN_FILTER,
  SET_REASON_ID_SHUTDOWN_FILTER,
  SET_DATE_RANGE_SHUTDOWN_FILTER,
  SET_DATE_RANGE_FIELD_SHUTDOWN_FILTER,
  SET_ADDRESS_IDS_SHUTDOWN_FILTER,
  SET_HOUSE_ID_SHUTDOWN_FILTER,
  SET_STREET_ID_SHUTDOWN_FILTER,
  SET_ONLY_ACTIVE_SHUTDOWN_FILTER,
  SET_INITIATOR_ID_SHUTDOWN_FILTER,
  SET_RESPOSIBLE_ID_SHUTDOWN_FILTER,
  SET_SHUTDOWN_FILTER_VALUES,
  RESET_SHUTDOWN_FILTER_VALUES,
  SET_CREATE_WORKER_ID_SHUTDOWN_FILTER,
  SET_CITY_ID_SHUTDOWN_FILTER,
  SET_IS_PLAYING_SHUTDOWN_FILTER,
  SET_FOR_EDDS_SHUTDOWN_FILTER,
  SET_SEARCH_VALUE_SHUTDOWN_FILTER,
  SET_VALUE_NEW_SHUTDOWN,
} from './types';
import { dateRangeShutdownsEnum } from '../../../shared/constants/dateRangeShutdownsEnum';

const defaultDateRange = [
  moment().subtract(3, 'month').add(1, 'days'),
  moment(),
];

const defaultFilterValue = {
  companyId: null,
  typeId: null,
  reasonId: null,
  dateRange: defaultDateRange,
  dateRangeField: dateRangeShutdownsEnum.START,
  streetId: null,
  houseId: null,
  addressIds: [],
  onlyActive: true,
  initiatorIds: [],
  executorIds: [],
  createWorkerId: null,
  cityId: null,
  isPlaying: null,
  forEdds: null,
};

const initialState = {
  visible: false,
  filterChanged: false,
  chosenFilterId: null,
  chosenFilterName: null,
  searchValue: null,
  newShutdown: null,
  ...defaultFilterValue,
};

const filterShutdownReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RESET_SHUTDOWN_FILTER_VALUES:
      return {
        ...initialState,
      };
    case SET_VALUE_NEW_SHUTDOWN:
      return {
        ...state,
        newShutdown: payload,
      };
    case SET_SEARCH_VALUE_SHUTDOWN_FILTER:
      return {
        ...state,
        searchValue: payload,
      };
    case SET_VISIBLE_SHUTDOWN_FILTER:
      return {
        ...state,
        visible: payload,
      };
    case SET_CHANHGED_SHUTDOWN_FILTER:
      return {
        ...state,
        filterChanged: payload,
      };
    case SET_CHOSEN_SHUTDOWN_FILTER:
      return {
        ...state,
        chosenFilterId: payload?.id || null,
        chosenFilterName: payload?.name || null,
      };
    case SET_COMPANY_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        companyId: payload,
        cityId: null,
        executorIds: [],
      };
    case SET_TYPE_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        typeId: payload,
      };
    case SET_REASON_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        reasonId: payload,
      };
    case SET_DATE_RANGE_SHUTDOWN_FILTER:
      return {
        ...state,
        dateRange: payload,
      };
    case SET_CITY_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        cityId: payload,
        initiatorIds: [],
      };
    case SET_DATE_RANGE_FIELD_SHUTDOWN_FILTER:
      return {
        ...state,
        dateRangeField: payload,
      };
    case SET_STREET_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        streetId: payload,
      };
    case SET_HOUSE_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        houseId: payload,
      };
    case SET_ADDRESS_IDS_SHUTDOWN_FILTER:
      return {
        ...state,
        addressIds: payload,
      };
    case SET_ONLY_ACTIVE_SHUTDOWN_FILTER:
      return {
        ...state,
        onlyActive: payload,
      };
    case SET_INITIATOR_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        initiatorIds: payload,
      };
    case SET_RESPOSIBLE_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        executorIds: payload,
      };
    case SET_CREATE_WORKER_ID_SHUTDOWN_FILTER:
      return {
        ...state,
        createWorkerId: payload,
      };
    case SET_IS_PLAYING_SHUTDOWN_FILTER:
      return {
        ...state,
        isPlaying: payload,
      };
    case SET_FOR_EDDS_SHUTDOWN_FILTER:
      return {
        ...state,
        forEdds: payload,
      };
    case SET_SHUTDOWN_FILTER_VALUES:
      return {
        ...state,
        ...payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default filterShutdownReducer; //filterShutdownStore
